<template>
  <div class="custom-alert error">
    <i class="bi bi-x-circle-fill icon"></i>
    <span class="message">
      {{ message }}
    </span>
  </div>
</template>

<script setup>
/* eslint-disable */
defineProps({
  message: String,
});
</script>

<style scoped>
.custom-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 14px;
}

.error {
  background: #fdecea;
  color: #b02a37;
}

.icon {
  font-size: 18px;
}
</style>
